const validateForm = (data, required, setter) => {
    let errors = {}
    required.forEach((key) => {
        let value = data[key]
        if(value === null || (typeof value === "string" && value.trim() === "")) {
            errors[key] = 'Pole jest wymagane.'
        }
    })
    if (Object.keys(errors).length !== 0) {
        setter(errors)
        return false
    }
    setter({})
    return true
}

export default validateForm
